import React from "react";
import classes from "./index.module.css";
import Text from "../Text";
import { ChevronSmallDown } from "@/components/Icons";
import { Accordion } from "@mantine/core";

interface FaqAccordionProps {
  header: string;
  body: React.ReactNode;
}

const FaqAccordion = ({ header, body }: FaqAccordionProps) => {
  return (
    <Accordion classNames={classes} chevron={<ChevronSmallDown />}>
      <Accordion.Item value="header">
        <Accordion.Control>
          <Text variant="subheadline_bold">{header}</Text>
        </Accordion.Control>
        <Accordion.Panel>{typeof body === "string" ? <Text variant="reading_medium">{body}</Text> : body}</Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default FaqAccordion;
